var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFileCloud = function SvgIconFileCloud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.013 2.513A1.75 1.75 0 0 1 5.25 2h9a1 1 0 0 1 .707.293l5.25 5.25a1 1 0 0 1 .293.707v12A1.75 1.75 0 0 1 18.75 22h-1.875a1 1 0 1 1 0-2H18.5V9.625h-4.625a1 1 0 0 1-1-1V4H5.5v7.625a1 1 0 1 1-2 0V3.75c0-.464.184-.91.513-1.237m10.862 5.112V5.039l2.586 2.586z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.125 11.849a5.124 5.124 0 0 0-5.665 2.905A3.625 3.625 0 0 0 5.625 22h4.5a5.125 5.125 0 0 0 1-10.151m-3.987 4.108a1 1 0 0 1-.037.132c-.067.255-.101.52-.101.786a1 1 0 1 1-2 0A1.625 1.625 0 0 0 5.625 20h4.5a3.125 3.125 0 1 0-2.987-4.043"
  }))));
};
export default SvgIconFileCloud;